import React, { useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Card, Grid, CircularProgress, Alert } from "@mui/material";
import { postUploadNoResponse } from "utils/WebService";
import fileDownload from 'js-file-download';
import { MySwal } from "App";

function ImportarRetorno() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [resultado, setResultado] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
            setResultado(null);
        }
    };

    const handleUpload = () => {
        if (!file) {
            MySwal.fire('Aviso', 'Selecione um arquivo de retorno (.ret) primeiro.', 'warning');
            return;
        }

        MySwal.fire({
            title: 'Deseja importar o arquivo?',
            text: "Caso este arquivo já tenha sido processado anteriormente, os registros já baixados ou atualizados serão ignorados automaticamente.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#4CAF50',
            cancelButtonColor: '#f44336',
            confirmButtonText: 'Sim, processar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const formData = new FormData();
                formData.append("file", file);

                postUploadNoResponse('/cnab/processar-retorno', formData)
                    .then(async (response) => {
                        const blob = await response.blob();
                        fileDownload(blob, "Relatorio_Retorno_CNAB.txt");
                        setResultado({ type: 'success', message: 'Processamento concluído. O relatório detalhado foi baixado automaticamente.' });
                        MySwal.fire('Sucesso', 'Arquivo de retorno processado!', 'success');
                        setFile(null);
                    })
                    .catch(err => {
                        console.error(err);
                        setResultado({ type: 'error', message: 'Erro ao processar o arquivo. Verifique o console.' });
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        });
    };

    return (
        <MDBox>
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={8}>
                    <MDTypography variant="h6" fontWeight="medium">
                        Importar Arquivo de Retorno (.ret)
                    </MDTypography>
                    <MDTypography variant="button" color="text" fontWeight="regular">
                        Selecione o arquivo de retorno disponibilizado pelo Bradesco para processar baixas, registros e rejeições.
                    </MDTypography>
                </Grid>
                
                <Grid item xs={12}>
                    <input
                        accept=".ret,.txt"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="raised-button-file">
                        <MDButton variant="outlined" color="info" component="span">
                            Selecionar Arquivo
                        </MDButton>
                    </label>
                    {file && (
                        <MDTypography variant="body2" sx={{ ml: 2, display: 'inline-block' }}>
                            Arquivo selecionado: <strong>{file.name}</strong>
                        </MDTypography>
                    )}
                </Grid>

                <Grid item xs={12}>
                    <MDButton 
                        variant="gradient" 
                        color="success" 
                        onClick={handleUpload}
                        disabled={!file || loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'PROCESSAR ARQUIVO'}
                    </MDButton>
                </Grid>

                {resultado && (
                    <Grid item xs={12}>
                        <Alert severity={resultado.type}>
                            {resultado.message}
                        </Alert>
                    </Grid>
                )}
            </Grid>
        </MDBox>
    );
}

export default ImportarRetorno;
